
import { Component, Vue, Prop, PropSync, Watch, Ref } from 'vue-property-decorator';
import { PresMusic } from "@/enum/nurse.enum";
import { fdmNurseRuleList, fdmNurseMedicinalList, fdmNurseSymptomList, fdmNurseEdit } from "@/api/consultation";

import { StatusEnum } from "@/enum/common.enum";

import { cloneDeep } from "lodash";

@Component({ name: 'fourCombine-components-FourNurseDialog' })
export default class FourNurseDialog extends Vue {
  @PropSync("dialogVisible") visible!: boolean;
  @PropSync("editData") readonly formBase!: Record<string, any>;

  @Ref('formRef') readonly formRef!: any;

  StatusEnum = StatusEnum;

  form = {} as any;

  // form = {
  //   name: '',
  //   symptomName: [],
  //   preRules: [],
  //   mutexRules: [],
  //   nurseDesc: '',
  //   nurseMusic: '',
  //   productName: [{ name: "" }],
  //   status: 1,
  // } as any;

  rules = {
    name: [{ required: true, message: '请输入四诊调养名称', trigger: 'blur' }],
    // symptomName: [{ required: true, type: 'array', min: 1, message: '请选择关联症状', trigger: 'change' }],
    // preRules: [{ required: true, type: 'array', min: 1, message: '请选择先导原则', trigger: 'change' }],
    // mutexRules: [{ required: true, type: 'array', min: 1, message: '请选择互斥原则', trigger: 'change' }],
    // nurseMusic: [{ required: true, message: '请选择音乐调养', trigger: 'change' }],
    // medicinesType: [{ required: true, message: '请选择类型', trigger: 'change' }],
    // medicinesName: [{ required: true, message: '请选择产品名称', trigger: 'change' }],
  };

  symptomOptions = [];
  musicOptions = [
  ];

  nurseOptions = [];
  medicinalOptions = [];

  getFdmNurseRuleList() {
    fdmNurseRuleList({ fragranceId: this.formBase.id || undefined }).then((res) => {
      console.log("222222222",res)
      this.nurseOptions = res.data;
    })
  }

  getFdmNurseMedicinalList() {
    fdmNurseMedicinalList().then((res) => {
      this.medicinalOptions = res.data;
    })
  }

  getFdmNurseSymptomList() {
    fdmNurseSymptomList().then((res) => {
      this.symptomOptions = res.data;
    })
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (val) {
      this.setMusicOptions();
      this.getFdmNurseRuleList();
      this.getFdmNurseMedicinalList();
      this.getFdmNurseSymptomList();
    }
  }

  @Watch('formBase', { deep: true })
  onEditDataChange() {
    console.log(this.formBase);
    const mutexRules = this.formBase?.mutexRules?.map(el => el.id)
    const preRules = this.formBase?.preRules?.map(el => el.id)
    const symptomName = this.formBase?.symptomName?.map((el) => `${el.source}-${el.id}`);
    const productName = this.formBase?.productName?.map((el) => el.id);

    this.form = cloneDeep({ ...this.formBase, productName, symptomName, mutexRules, preRules });
    // this.initForm();
  }

  transferChange($event) {
    const max = 6;
    this.form.productName = $event.slice(0, max);
    if ($event.length > 6) {
      this.$message.warning("四诊药香最多选择6项");
    }
  }

  setMusicOptions() {
    const keyList = Object.keys(PresMusic);
    this.musicOptions = [
        {label: "随机", value: 0},
        ...keyList?.slice((keyList?.length/2 + 1), keyList?.length)?.map((el, index) => {
            return ({ label: el, value: index + 1 })
        }),
    ]
  }

  handleClose() {
    this.formRef?.resetFields();
    this.visible = false;
  }

  handleSubmit() {
    (this.$refs.formRef as any).validate((valid: boolean) => {
      if (valid) {
        const { id, name, nurseStatus, nurseDesc, mutexRules, preRules } = this.form;
        console.log(this.form)
        const params = {
          id,
          name,
          nurseDesc,
          nurseMusic: this.getMusic(),
          nurseStatus,
          mutexRules: this.getRules(mutexRules) || [],
          preRules: this.getRules(preRules) || [],
          productName: this.getProductName() || [],
          symptomName: this.getSymptomName() || [],
        }
        fdmNurseEdit(params).then((res) => {
          console.log("res", res)
          this.$message.success("操作成功");
          this.handleClose();
          this.$emit("refreshList");
        })
      }
    });
  }

  getRules(list) {
    return list?.map(el => {
      return this.nurseOptions?.find(n => n.id == el);
    })
  }

  getMusic() {
    console.log(this.form.nurseMusic)
    if (this.form.nurseMusic == "随机") {
      const num = Math.floor(Math.random() * 52);
      console.log("212121", this.musicOptions, num)
          return this.musicOptions[num].label;
      }
      return this.form.nurseMusic;
  }


  getSymptomName() {
    return this.form.symptomName?.map((el) => {
      const [source, id] = el.split("-");
      const symptom = this.symptomOptions?.find(s => s.source == source && s.id == id);
      return symptom;
    })
  }

  getProductName() {
    console.log(this.form.productName)
    return this.form.productName?.map((el) => {
      const product = this.medicinalOptions?.find((s) => s.id == el)
      return product
    })
  }
}
